import React, { useState } from 'react';
import { Paper, Box, Button, Typography, Dialog, DialogTitle, DialogContent, Grid, TextField } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useNavigate } from 'react-router-dom';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Loading from './Loading';
import pickupIcon from '../img/pickup.png';
import deliveryIcon from '../img/delivery.png';
import hazmat from '../img/hazmat.png';
import axios from 'axios';
import { useDateTimePicker } from '../hooks/useDateTimePicker';
import { useModal } from 'mui-modal-provider';
import DriverHoursDialog from './DriverHoursDialog';
import { useConfirm } from 'material-ui-confirm';


import {
    useBackdrop
} from '../hooks/useBackdrop';


const renderEventTypeIcon = (type) => {
    let imageCode;

    switch (type.toLowerCase()) {
        case 'drop':
            imageCode = deliveryIcon;
            break;
        case 'pickup':
            imageCode = pickupIcon;
            break;
        default:
            imageCode = deliveryIcon;
    }
    return (
        <img src={imageCode} height="24px" style={{ filter: 'invert(18%) sepia(99%) saturate(1108%) hue-rotate(187deg) brightness(93%) contrast(96%)', marginTop: '3px' }} />
    )
}

export default function EventCard({ event, load }) {

    const { openBackdrop, closeBackdrop } = useBackdrop();
    const { selectedValue, openDateTimePicker, DateTimePicker } = useDateTimePicker();

    const isHazmat = event.hazmat == "true" ? true : false;
    const navigate = useNavigate();
    const confirm = useConfirm();


    console.log(event);

    const { showModal } = useModal();


    const handleSubmit = (stopType) => {
        var dateTime = new Date().toLocaleString('en-CA', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).replace(',', '')

        confirm({ dialogProps: { fullScreen: true }, description: 'Current Time is ' + dateTime })
            .then(() => {
                if (event.lastStop == true && stopType == 'departure') {
                    showModal(DriverHoursDialog, {
                        title: 'Driver Hours',
                        open: true,
                        submitDate: dateTime,
                        stopType,
                        onSubmit: submitTime,
                        onClose: () => { }
                    });
                    return;
                }
                submitTime(dateTime, stopType, 0);

            })
            .catch(() => { /* ... Cancelled */ });
    };



    const submitTime = (dateTime, stopType, hours) => {

        openBackdrop(
            <div>
                <Loading />
            </div>

        );

        let formattedDateTime = dateTime.toLocaleString('en-CA', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).replace(',', '');
        let url = `/api/prod/mobile_api.php?action=update&load=${load.load_number}&datetime=${formattedDateTime}&pro=${load.pro}&scac=${load.scac}&stop=${event.stop_number}&city=${event.city}&prov=${event.state}`;

        if (stopType == 'arrival') {
            url += `&status=${event.arrival_code}`
        }
        else if (stopType == 'departure') {
            url += `&status=${event.depart_code}`
        }

        if (hours && hours != 0) {
            url += `&hours=${hours}`
        }

        axios.get(url)
            .then(res => {
                closeBackdrop();
                navigate('/success');
            })
            .catch(err => {
                closeBackdrop();
                navigate('/error');
            })
    }



    return (
        <div>
            <Paper square elevation={4} sx={{ minHeight: '150px', position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <Box id="contentContainer" sx={{ padding: '15px', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                    <Box id="icons" sx={{ display: 'flex', flexDirection: 'column' }}>
                        {renderEventTypeIcon(event.type)}
                        {isHazmat ? (<>
                            <img src={hazmat} height="24px" style={{ marginTop: '10px' }} />

                        </>) : null}
                    </Box>

                    <Box sx={{ marginLeft: '15px', display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ typography: "subtitle2", fontWeight: 600, textTransform: "uppercase", color: 'primary.dark' }} >{event.type}</Box>
                        <Box sx={{ typography: 'caption' }} >{event.location_name}</Box>
                        <Box sx={{ typography: 'caption', color: '#7d8187' }}>{event.address}</Box>
                        <Box sx={{ typography: 'caption', color: '#7d8187' }}>{event.city}, {event.state}</Box>
                        <Box sx={{ typography: 'caption' }}>{event.target_early} - {event.target_late}</Box>
                        {isHazmat ? <Box sx={{ typography: 'caption', color: '#7d8187' }}>(Hazmat)</Box> : null}
                    </Box>


                </Box>

                <Box id="actionContainer" sx={{ display: 'flex', width: '100%' }}>
                    <Button startIcon={event.arrival_date ? <CheckCircleRoundedIcon color="success" /> : null} name="arrival" onClick={() => handleSubmit('arrival')} disableElevation sx={{ borderRadius: 0 }} color="secondary" disabled={!event.canArrive} fullWidth variant="contained">
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                            <Box sx={{ typography: 'caption' }}>Arrival</Box>

                            {event.arrival_date ? <Box sx={{ fontSize: '10px' }}>{event.arrival_date}</Box> : null}

                        </Box>
                    </Button>
                    <Button startIcon={event.departure_date ? <CheckCircleRoundedIcon color="success" /> : null} name="departure" onClick={() => handleSubmit('departure')} disableElevation sx={{ borderRadius: 0 }} color="primary" disabled={!event.canDepart} f fullWidth variant="contained">
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                            <Box sx={{ typography: 'caption' }}>Departure</Box>

                            {event.departure_date ? <Box sx={{ fontSize: '10px' }}>{event.departure_date}</Box> : null}
                        </Box>
                    </Button>
                </Box>
            </Paper>
        </div >
    );
}